export const API_URL = 'https://localhost:9101/';
export const API_URL_HTTP = 'http://localhost:9100/';
